<template lang="html">
  <TFinderLayout>
    <template #sidebar>
      <div class="color-white-04">ADMIN.dashboard</div>
      <TFlex
        class="cursor-pointer mb-2 mt-2 red"
        >
        <v-icon class="color-white-09 mr-1" small>group_add</v-icon>
        <div class="color-white-09">APPLICATION.ranking</div>
      </TFlex>
      <!-- UserInvites -->
      <TFlex
        v-if="hasPermission('Project Invite READ ALL')"
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'UserInvites'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'UserInvites'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>person_add</v-icon>
        <div class="color-white-09">USER.invites</div>
      </TFlex>
      <!-- UserSearch -->
      <TFlex
        v-if="hasPermission('User READ ALL')"
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'UserSearch'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'UserSearch'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>person_search</v-icon>
        <div class="color-white-09">USER.search</div>
      </TFlex>
      <!-- UserUpgrades -->
      <TFlex
        v-if="hasPermission('UserUpgrade READ ALL')"
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'UserUpgrades'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'UserUpgrades'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>person_add_alt_1</v-icon>
        <div class="color-white-09">USER.upgrades</div>
      </TFlex>
      <!-- ProUser -->
      <TFlex
        v-if="hasPermission('UserUpgrade READ ALL')"
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'ProUser'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'ProUser'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>verified_user</v-icon>
        <div class="color-white-09">PRO.user</div>
      </TFlex>
      <!-- DeactivatedUser -->
      <TFlex
        class="cursor-pointer mb-2 mt-2 red"
        >
        <v-icon class="color-white-09 mr-1" small>no_accounts</v-icon>
        <div class="color-white-09">DEACTIVATED.user</div>
      </TFlex>
      <!-- RecentlyActiveUser -->
      <TFlex
        v-if="hasPermission('User READ ALL')"
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'RecentlyActiveUser'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'RecentlyActiveUser'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>face</v-icon>
        <div class="color-white-09">ACTIVE.user</div>
      </TFlex>
      <!-- Subscribers -->
      <TFlex
        class="cursor-pointer mb-2 mt-2 red"
        >
        <v-icon class="color-white-09 mr-1" small>notifications_none</v-icon>
        <div class="color-white-09">Subscribers</div>
      </TFlex>
      <!-- Community -->
      <TFlex
        v-if="hasPermission('Community State READ ALL')"
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'Community'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'Community'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>people_outline</v-icon>
        <div class="color-white-09">Community</div>
      </TFlex>
      <!-- Stats -->
      <TFlex
        v-if="hasPermission('Stats READ')"
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'Stats'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'Stats'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>poll</v-icon>
        <div class="color-white-09">Stats</div>
      </TFlex>
      <!-- TAKTNEWS -->
      <TFlex
        v-if="hasPermission('TAKTNEWS CREATE')"
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'TaktNews'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'TaktNews'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>article</v-icon>
        <div class="color-white-09">TAKT.news</div>
      </TFlex>
      <!-- BugReports -->
      <TFlex
        v-if="hasPermission('BUG READ ALL')"
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'BugReports'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'BugReports'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>bug_report</v-icon>
        <div class="color-white-09">BUG.reports</div>
      </TFlex>
      <TFlex
        class="cursor-pointer mb-2 mt-2 red"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'EmailSuppressionList'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>email</v-icon>
        <div class="color-white-09">EmailSuppressionList</div>
      </TFlex>
      <TFlex
        v-if="hasPermission('Material API READ')"
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'MaterialAPIDashboard'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'MaterialAPIDashboard'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <svg-icon name="tool-hammer"/>
        <!-- tools-hammer-screwdriver -->
        <div class="color-white-09">MaterialAPIDashboard</div>
      </TFlex>
    </template>
    <template #actionbar>
      <div v-if="$route.matched[1] && $route.matched[1].name === 'Stats'">
        <v-btn @click="loadStats('hist/userstats', 'set_user_hist_stats')">user stats</v-btn>
        <v-btn @click="loadStats('hist/projectstats', 'set_project_hist_stats')">project stats</v-btn>
        <v-btn @click="loadStats('hist/sequencestats', 'set_sequence_hist_stats')">sequence stats</v-btn>
        <v-btn @click="loadStats('hist/workpackagestats', 'set_workpackage_hist_stats')">work package stats</v-btn>
        <v-btn @click="loadStats('stats/mcallbacks', 'set_mcallbacks_stats')">callback stats</v-btn>
        <v-btn @click="loadStats('stats/mcustomerrequests', 'set_mcustomerrequests_stats')">api stats</v-btn>
        <v-progress-circular v-if="isLoading" style="position:absolute; right: 15px;" indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-if="$route.matched[1] && $route.matched[1].name === 'BugReports'">
        Current offset: {{ $store.state.BugReport.meta_data.offset }} Total: {{ $store.state.BugReport.meta_data.total }}
        <v-btn @click="requestBugsForManagement(`?limit=10&offset=${$store.state.BugReport.meta_data.offset + 10}`)">Load 10 more</v-btn>
      </div>
    </template>
    <template #content>
      <router-view/>
    </template>
  </TFinderLayout>
</template>

<script>
import { TFinderLayoutMixin } from '@/mixins/TFinderLayout.mixin.js'
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'Dashboard',
  mixins: [TFinderLayoutMixin],
  created(){

  },
  computed: {
    ...mapGetters('Auth', [
      'hasPermission',
      'hasOneOfPermissions'
    ]),
    ...mapGetters('Stats', [
      'isLoading'
    ]),
  },
  methods: {
    ...mapActions('BugReport', [
      'requestBugsForManagement'
    ]),
    getActive(){
      switch (this.$route.name) {
        case 'Stats': return 0;
        case 'ApplicationRanking': return 1;
        case 'Community': return 2;
        case 'UserInvites': return 3;
        case 'Subscribers': return 4;
        case 'BugReports': return 5;
        default: return -1;
      }
    },
    showText(){
      return this.$vuetify.breakpoint.mdAndUp;
    },
    loadStats(url, mutation){
      this.$store.dispatch('Stats/requestStats', {
        url,
        mutation
      });
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
